export const DEMO_ACCOUNTS = [
  {
    key: 'fire',
    fireType: 'regular',
    token: 'demo-fire',
    supabaseUserId: '11111111-1111-4111-8111-111111111111',
    email: 'demo+fire@perdiem.app',
    label: 'FIRE',
    title: 'High Income, Low Burn',
    summary: 'Single early-career high earner keeping expenses lean to reach FI as soon as possible.',
    household: 'Single',
    location: 'Seattle, WA',
    ageLabel: 'Age 30',
  },
  {
    key: 'alreadyfi',
    fireType: 'regular',
    token: 'demo-alreadyfi',
    supabaseUserId: '46464646-4646-4646-8646-464646464646',
    email: 'demo+alreadyfi@perdiem.app',
    label: 'Already FI',
    title: 'Life After the Finish Line',
    summary: 'A retired couple funding a $72,000 annual lifestyle from their portfolio. Explore retirement confidence, spending, and their long-term plan.',
    household: 'Married, retired',
    location: 'Raleigh, NC',
    ageLabel: 'Ages 58 & 56',
  },
  {
    key: 'fatfire',
    fireType: 'fat',
    token: 'demo-fatfire',
    supabaseUserId: '22222222-2222-4222-8222-222222222222',
    email: 'demo+fatfire@perdiem.app',
    label: 'FatFIRE',
    title: 'Can We Keep This Life?',
    summary: 'Married dual-income household optimizing for financial independence without cutting a luxury lifestyle.',
    household: 'Married, 2 kids',
    location: 'Brooklyn, NY',
    ageLabel: 'Ages 44 & 42',
  },
  {
    key: 'baristafire',
    fireType: 'barista',
    token: 'demo-baristafire',
    supabaseUserId: '33333333-3333-4333-8333-333333333333',
    email: 'demo+baristafire@perdiem.app',
    label: 'BaristaFIRE',
    title: 'The Part-Time Bridge',
    summary: 'Planning the transition to lower-stress part-time work while balancing benefits, spending, and retirement savings.',
    household: 'Single',
    location: 'Boulder, CO',
    ageLabel: 'Age 38',
  },
  {
    key: 'coastfire',
    fireType: 'coast',
    token: 'demo-coastfire',
    supabaseUserId: '44444444-4444-4444-8444-444444444444',
    email: 'demo+coastfire@perdiem.app',
    label: 'CoastFIRE',
    title: 'Portfolio Doing the Heavy Lifting',
    summary: 'A single parent balancing college costs, today’s spending, and the long-term growth of existing investments.',
    household: 'Single parent',
    location: 'Raleigh, NC',
    ageLabel: 'Age 37',
  },
  {
    key: 'gregfire',
    fireType: 'regular',
    token: 'demo-gregfire',
    supabaseUserId: '45454545-4545-4545-8545-454545454545',
    email: 'demo+gregfire@perdiem.app',
    label: 'GregFIRE',
    title: 'Poorest Rich Person in America',
    summary: 'Highest paid assistant in human history. Apparently going to inherit $5 million.',
    household: 'Single',
    location: 'New York, NY',
    ageLabel: 'Age 29',
    contextVideos: [
      {
        title: 'Poorest Rich Person in America',
        embedUrl: 'https://www.youtube.com/embed/m0sRrsara9c?rel=0&modestbranding=1',
      },
      {
        title: 'The highest paid assistant',
        embedUrl: 'https://www.youtube.com/embed/PF_7ul3i6Y8?start=50&rel=0&modestbranding=1',
      },
    ],
  },
] as const;

/**
 * Reddit-sourced demo profiles — generated from real r/FIRE posts to power
 * personalised demo links shared in Reddit comments.
 *
 * These are structurally identical to the main demo accounts but live in a
 * separate array so the landing-page demo picker only shows canonical profiles
 * while the `/demo/[handle]` route can resolve any Reddit-sourced demo.
 */
export const REDDIT_DEMO_ACCOUNTS = [
  {
    key: 'reddit-significantbuddy8686',
    fireType: 'coast',
    token: 'demo-reddit-significantbuddy8686',
    supabaseUserId: '55555555-5555-4555-8555-555555555555',
    email: 'demo+reddit-significantbuddy8686@perdiem.app',
    label: 'ChubbyFIRE',
    title: 'Should I take the job and "chubby coast?"',
    summary: '47-year-old tech sales exec with $2.5M investable + $1.3M real estate, weighing a $160K offer to coast to FIRE by 53.',
    household: 'Single',
    location: 'U.S.',
    ageLabel: 'Age 47',
    redditHandle: 'SignificantBuddy8686',
    redditSubreddit: 'r/ChubbyFIRE',
    redditPostDate: '2026-03-25',
  },
  {
    key: 'reddit-gaygler-nyc',
    fireType: 'regular',
    token: 'demo-reddit-gaygler-nyc',
    supabaseUserId: '66666666-6666-4666-8666-666666666666',
    email: 'demo+reddit-gaygler-nyc@perdiem.app',
    label: 'FIRE',
    title: 'Retire at 38 — Stay in NYC',
    summary: '38-year-old senior tech worker with $3.6M NW. Scenario: retire now in NYC at $175K/yr burn rate with rental income.',
    household: 'Single',
    location: 'New York, NY',
    ageLabel: 'Age 38',
    redditHandle: 'gaygler-nyc',
    redditSubreddit: 'r/Fire',
    redditPostDate: '2026-02-15',
  },
  {
    key: 'reddit-gaygler-canada',
    fireType: 'regular',
    token: 'demo-reddit-gaygler-canada',
    supabaseUserId: '77777777-7777-4777-8777-777777777777',
    email: 'demo+reddit-gaygler-canada@perdiem.app',
    label: 'FIRE',
    title: 'Retire at 38 — Move to Canada',
    modalDescription: 'Illustrative USD scenario using U.S. tax assumptions. Canadian and cross-border taxes are not modeled; the spending and property-sale assumptions are available in the plan.',
    summary: '38-year-old senior tech worker with $3.6M NW. Scenario: sell the NYC co-op, move to Canada, live on $60–75K/yr.',
    household: 'Single',
    location: 'Toronto, ON',
    ageLabel: 'Age 38',
    redditHandle: 'gaygler-canada',
    redditSubreddit: 'r/Fire',
    redditPostDate: '2026-02-15',
  },
  {
    key: 'reddit-throwthrowff',
    fireType: 'fat',
    token: 'demo-reddit-throwthrowff',
    supabaseUserId: '88888888-8888-4888-8888-888888888888',
    email: 'demo+reddit-throwthrowff@perdiem.app',
    label: 'FatFIRE',
    title: 'Forced sabbatical: grind or coast?',
    summary: 'Bay Area couple in their mid-40s with $10M NW, two toddlers, and a decision between another big job push or coasting now.',
    household: 'Married, 2 kids',
    location: 'Bay Area, CA',
    ageLabel: 'Mid-40s',
    redditHandle: 'Throwthrowff',
    redditSubreddit: 'r/fatFIRE',
    redditPostDate: '2026-01-23',
  },
  {
    key: 'reddit-bribriadventures',
    fireType: 'fat',
    token: 'demo-reddit-bribriadventures',
    supabaseUserId: '99999999-9999-4999-8999-999999999999',
    email: 'demo+reddit-bribriadventures@perdiem.app',
    label: 'FatFIRE',
    title: 'Retire at chubby, compound to fat',
    summary: 'High-income couple with $4.5M liquid NW asking whether they can stop now, stay frugal, and let returns carry them into fatFIRE.',
    household: 'Married',
    location: 'U.S.',
    ageLabel: 'Peak earning years',
    redditHandle: 'bribriadventures',
    redditSubreddit: 'r/fatFIRE',
    redditPostDate: '2026-01-13',
  },
  {
    key: 'reddit-electrical-trainer21',
    fireType: 'lean',
    token: 'demo-reddit-electrical-trainer21',
    supabaseUserId: 'aaaaaaaa-aaaa-4aaa-8aaa-aaaaaaaaaaaa',
    email: 'demo+reddit-electrical-trainer21@perdiem.app',
    label: 'LeanFIRE',
    title: 'Retire on $650K?',
    summary: '25-year-old single leanFIRE scenario testing whether $650K can realistically support $30K annual spending for the long haul.',
    household: 'Single',
    location: 'U.S.',
    ageLabel: 'Age 25',
    redditHandle: 'Electrical-Trainer21',
    redditSubreddit: 'r/leanfire',
    redditPostDate: '2026-02-15',
  },
  {
    key: 'reddit-flat-barracuda1268',
    fireType: 'regular',
    token: 'demo-reddit-flat-barracuda1268',
    supabaseUserId: 'bbbbbbbb-bbbb-4bbb-8bbb-bbbbbbbbbbbb',
    email: 'demo+reddit-flat-barracuda1268@perdiem.app',
    label: 'FIRE',
    title: 'One year out: are we there?',
    summary: 'Midwest couple in their early 50s with $4.3M invested, a second-home build ahead, and a planned 2027 retirement date.',
    household: 'Married',
    location: 'Midwest, U.S.',
    ageLabel: 'Ages 53 & 53',
    redditHandle: 'Flat-Barracuda1268',
    redditSubreddit: 'r/Fire',
    redditPostDate: '2026-01-04',
  },
  {
    key: 'reddit-blueorca123',
    fireType: 'fat',
    token: 'demo-reddit-blueorca123',
    supabaseUserId: 'cccccccc-cccc-4ccc-8ccc-cccccccccccc',
    email: 'demo+reddit-blueorca123@perdiem.app',
    label: 'ChubbyFIRE',
    title: 'Ready to retire, not ready to spend',
    summary: 'Early-50s couple earning $700K household income, financially secure on paper, but hesitant to spend freely once paychecks stop.',
    household: 'Married',
    location: 'U.S.',
    ageLabel: 'Early 50s',
    redditHandle: 'blueorca123',
    redditSubreddit: 'r/ChubbyFIRE',
    redditPostDate: '2026-04-01',
  },
  {
    key: 'reddit-existingdifference93',
    fireType: 'regular',
    token: 'demo-reddit-existingdifference93',
    supabaseUserId: 'dddddddd-dddd-4ddd-8ddd-dddddddddddd',
    email: 'demo+reddit-existingdifference93@perdiem.app',
    label: 'FIRE',
    title: 'Is it time at 57?',
    summary: '57-year-old with $3.1M across retirement, ESOP, brokerage, and cash, asking whether $82K annual spend is already covered.',
    household: 'Single',
    location: 'U.S.',
    ageLabel: 'Age 57',
    redditHandle: 'ExistingDifference93',
    redditSubreddit: 'r/Fire',
    redditPostDate: '2026-03-08',
  },
  {
    key: 'reddit-dos-comma-club',
    fireType: 'regular',
    token: 'demo-reddit-dos-comma-club',
    supabaseUserId: 'eeeeeeee-eeee-4eee-8eee-eeeeeeeeeeee',
    email: 'demo+reddit-dos-comma-club@perdiem.app',
    label: 'FIRE',
    title: 'Coast or grind in SoCal?',
    summary: 'Southern California couple with $3.5M NW deciding whether to keep a cushy job or take a higher-paying role to accelerate FIRE.',
    household: 'Married, 1 kid',
    location: 'Southern California',
    ageLabel: 'Ages 39 & 36',
    redditHandle: 'dos-comma-club',
    redditSubreddit: 'r/financialindependence',
    redditPostDate: '2026-02-17',
  },
  {
    key: 'reddit-dos-comma-club-high-pay',
    fireType: 'regular',
    token: 'demo-reddit-dos-comma-club-high-pay',
    supabaseUserId: '17171717-1717-4717-8717-171717171717',
    email: 'demo+reddit-dos-comma-club-high-pay@perdiem.app',
    label: 'FIRE',
    title: 'Higher-pay job in SoCal?',
    summary: 'Southern California couple with $3.5M NW comparing their current cushy path against a higher-paying role that could accelerate FIRE.',
    household: 'Married, 1 kid',
    location: 'Southern California',
    ageLabel: 'Ages 39 & 36',
    redditHandle: 'dos-comma-club-higher-pay',
    redditSubreddit: 'r/financialindependence',
    redditPostDate: '2026-02-17',
  },
  {
    key: 'reddit-pitayafrenesi',
    fireType: 'coast',
    token: 'demo-reddit-pitayafrenesi',
    supabaseUserId: '12121212-1212-4212-8212-121212121212',
    email: 'demo+reddit-pitayafrenesi@perdiem.app',
    label: 'CoastFIRE',
    title: 'Baby #2 and a Texas reset',
    summary: 'Family with $1.1M invested, a second child on the way, and a question of when they can downshift and relocate to small-town Texas.',
    household: 'Married, 1 kid + baby',
    location: 'Small-town Texas',
    ageLabel: 'Ages 37 & 35',
    redditHandle: 'pitayafrenesi',
    redditSubreddit: 'r/coastFIRE',
    redditPostDate: '2026-03-13',
  },
  {
    key: 'reddit-m-suzanne',
    fireType: 'coast',
    token: 'demo-reddit-m-suzanne',
    supabaseUserId: '13131313-1313-4313-8313-131313131313',
    email: 'demo+reddit-m-suzanne@perdiem.app',
    label: 'CoastFIRE',
    title: 'Quit and coast on freelance',
    summary: 'Household modeled after one partner already leaving an $83K job to coast on freelance income plus a spouse salary.',
    household: 'Married',
    location: 'U.S.',
    ageLabel: 'Ages 41 & 39',
    redditHandle: 'm_suzanne',
    redditSubreddit: 'r/coastFIRE',
    redditPostDate: '2026-03-15',
  },
  {
    key: 'reddit-jimbozeubuen',
    fireType: 'barista',
    token: 'demo-reddit-jimbozeubuen',
    supabaseUserId: '15151515-1515-4515-8515-151515151515',
    email: 'demo+reddit-jimbozeubuen@perdiem.app',
    label: 'BaristaFIRE',
    title: 'How soon can I retire at 39?',
    summary: '39-year-old with $3M NW, $300K comp, and a current lifestyle that looks sustainable around $60K annual spend.',
    household: 'Single',
    location: 'U.S.',
    ageLabel: 'Age 39',
    redditHandle: 'jimbozeubuen',
    redditSubreddit: 'r/Fire',
    redditPostDate: '2026-01-28',
  },
  {
    key: 'reddit-responsibility-fast',
    fireType: 'coast',
    token: 'demo-reddit-responsibility-fast',
    supabaseUserId: '16161616-1616-4616-8616-161616161616',
    email: 'demo+reddit-responsibility-fast@perdiem.app',
    label: 'CoastFIRE',
    title: 'How close to coastFI at 26?',
    summary: '26-year-old with roughly $486K invested and a milestone question about when compounding starts doing the heavy lifting.',
    household: 'Single',
    location: 'U.S.',
    ageLabel: 'Age 26',
    redditHandle: 'Responsibility_Fast',
    redditSubreddit: 'r/coastFIRE',
    redditPostDate: '2026-03-23',
  },
  {
    key: 'reddit-zachmelloh-sequence-risk',
    fireType: 'regular',
    token: 'demo-reddit-zachmelloh-sequence-risk',
    supabaseUserId: '18181818-1818-4818-8818-181818181818',
    email: 'demo+reddit-zachmelloh-sequence-risk@perdiem.app',
    label: 'FIRE',
    title: 'Does the plan survive a bad start?',
    summary: 'John and Lisa are both 62 with $1.8M saved and a $72K retirement budget. This demo stress-tests a rough first few years, a cash buffer, and what spending flex buys them.',
    modalDescription: 'We modeled the thread’s core question directly: can a newly retired couple handle an ugly first 2 to 3 years without being forced to sell too much too early? Open the profile to inspect the budget, the cash reserve, and how much flexibility matters.',
    household: 'Married',
    location: 'U.S.',
    ageLabel: 'Ages 62 & 62',
    redditHandle: 'zachmelloh-sequence-risk',
    redditSubreddit: 'X thread',
    redditPostDate: '2026-04-13',
  },
  {
    key: 'zachmelloh-tax-naive',
    fireType: 'regular',
    token: 'demo-zachmelloh-tax-naive',
    supabaseUserId: '19191919-1919-4919-8919-191919191919',
    email: 'demo+zachmelloh-tax-naive@perdiem.app',
    label: 'FIRE',
    title: 'Retirement without tax strategy',
    summary: 'Linda and Mark are 68 with $2.1M saved. This demo shows what happens with no Roth conversions, no bracket management, and simple even withdrawals.',
    modalDescription: 'The "naive" baseline: no Roth conversions, no IRMAA guardrails, and a simple withdrawal order. Compare this to the optimized version to see how much tax strategy alone changes the picture.',
    household: 'Married',
    location: 'North Carolina',
    ageLabel: 'Ages 68 & 68',
    redditHandle: 'zachmelloh-tax-naive',
    redditSubreddit: 'X thread',
    redditPostDate: '2026-04-14',
  },
  {
    key: 'zachmelloh-tax-optimized',
    fireType: 'regular',
    token: 'demo-zachmelloh-tax-optimized',
    supabaseUserId: '20202020-2020-4020-8020-202020202020',
    email: 'demo+zachmelloh-tax-optimized@perdiem.app',
    label: 'FIRE',
    title: 'Retirement with tax strategy',
    summary: 'Same couple, same $2.1M — but with Roth conversions, IRMAA guardrails, and tax-optimized withdrawals. Compare to the naive version.',
    modalDescription: 'The "optimized" version: Roth conversions fill to the 22% bracket, IRMAA guardrails limit Medicare surcharges, and blended tax-optimized withdrawals preserve Roth assets. Same household, very different outcome.',
    household: 'Married',
    location: 'North Carolina',
    ageLabel: 'Ages 68 & 68',
    redditHandle: 'zachmelloh-tax-optimized',
    redditSubreddit: 'X thread',
    redditPostDate: '2026-04-14',
  },
] as const;

export type DemoAccountKey = (typeof DEMO_ACCOUNTS)[number]['key'] | (typeof REDDIT_DEMO_ACCOUNTS)[number]['key'];

type DemoAccount = (typeof DEMO_ACCOUNTS)[number];
type RedditDemoAccount = (typeof REDDIT_DEMO_ACCOUNTS)[number];
type AnyDemoAccount = DemoAccount | RedditDemoAccount;

const ALL_DEMO_ACCOUNTS: readonly AnyDemoAccount[] = [...DEMO_ACCOUNTS, ...REDDIT_DEMO_ACCOUNTS];

export const DEMO_ACCOUNTS_BY_KEY = Object.fromEntries(
  ALL_DEMO_ACCOUNTS.map((account) => [account.key, account]),
) as Record<DemoAccountKey, AnyDemoAccount>;

export const DEMO_ACCOUNTS_BY_TOKEN = Object.fromEntries(
  ALL_DEMO_ACCOUNTS.map((account) => [account.token, account]),
) as Record<string, AnyDemoAccount>;

/** Map Reddit handle (lowercased) → demo account key for URL resolution. */
export const REDDIT_DEMO_BY_HANDLE = Object.fromEntries(
  REDDIT_DEMO_ACCOUNTS.map((account) => [account.redditHandle.toLowerCase(), account]),
) as Record<string, RedditDemoAccount>;
